export default {
  state: {
    notificationList: null,
    notificationTotalCount: null,
    notificationSingle: null,
    notificationStatistics: null
  },
  mutations: {
    setNotificationList (state, payload) {
      state.notificationList = payload
    },
    setNotificationTotalCount (state, payload) {
      state.notificationTotalCount = payload
    },
    setNotificationSingle (state, payload) {
      state.notificationSingle = payload
    },
    setNotificationStatistics (state, payload) {
      state.notificationStatistics = payload
    }
  },
  actions: {
    getNotificationList ({commit, dispatch}, {mode, offset, limit}) {
      const url = '/admin/notification/list?access_token=' + this.getters.accessToken + '&mode=' + mode + '&offset=' + offset + '&limit=' + limit
      dispatch('apiGet', url)
        .then((data) => {
          commit('setNotificationList', data.notification_list)
          commit('setNotificationTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getNotificationSingle ({commit, dispatch}, {id}) {
      const url = '/admin/notification/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setNotificationSingle', data.notification)
        })
        .catch((error) => {
          throw error
        })
    },
    getNotificationStatistics ({commit, dispatch}, {id}) {
      const url = '/admin/notification/' + id + '/statistics?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setNotificationStatistics', data.statistics)
        })
        .catch((error) => {
          throw error
        })
    },
    deleteNotification ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/notification/' + id + '/remove?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Сообщение удалено успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    async createNotification ({commit, dispatch}, notification) {
      let post = {
        data: {
          title: notification.notificationTitle,
          description: notification.description,
          planned_send_datetime: notification.plannedSendDatetime,
          type: notification.type
        }
      }

      if (notification.branchId !== null && typeof notification.branchId !== 'undefined') {
        post.data.branch_id = notification.branchId
      }

      if (notification.saleGroupId !== null && typeof notification.saleGroupId !== 'undefined') {
        post.data.sale_group_id = notification.saleGroupId
      }

      if (notification.userGroupId !== null && typeof notification.userGroupId !== 'undefined') {
        post.data.user_group_id = notification.userGroupId
      }

      if (notification.type === '2') {
        post.data.type = 2
        post.data.notification_option_list = notification.notificationOptions
      } else {
        post.data.type = 1
      }

      let returnData = null
      if (notification.id === null) {
        post.url = '/admin/notification/add?access_token=' + this.getters.accessToken
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Сообщение создано успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        post.id = notification.id
        post.url = '/admin/notification/' + notification.id + '/update?access_token=' + this.getters.accessToken

        console.log(post)
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Сообщение изменено успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    }
  },
  getters: {
    notificationList (state) {
      return state.notificationList
    },
    notificationTotalCount (state) {
      return state.notificationTotalCount
    },
    notificationSingle (state) {
      return state.notificationSingle
    },
    notificationStatistics (state) {
      return state.notificationStatistics
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/notification.js